<template>
  <div class="home">
    <span class="title">{{map.name}}</span><br>
    <span class="title">{{map.text}}</span><br>
    <span class="title">{{time}}</span><br>
    <span class="title">{{map.map}}</span><br>

  </div>
</template>

<script>
export default {
  props: {
    mapId: {
      type: String,
      required: true,
    },
  },
  mounted() {
    this.$store.dispatch('map', this.mapId);
  },
  computed: {
    map() {
      return this.$store.state.map;
    },
    time() {
      const a = new Date(Number(this.map.ts));
      return a.toLocaleString('fi-FI');
    },
  },
  components: {
  },
  methods: {
  },
};
</script>
